<template>
    <section>
    <div>
        <sui-segment basic>
            <h2 is="sui-header" floated="right" color="grey">
                <sui-icon name="building"/>
                <sui-header-content>Actualizacion de localidades</sui-header-content>
            </h2>
            <br><br>
        </sui-segment>
        <div class="ui grid">
            <div class="thirteen wide column">
                <sui-segment>
                    <sui-header dividing>Datos Generales</sui-header>
                    <div class="ui three column very relaxed grid">
                        <div class="column">
                            <h3>Resumen</h3>
                            <sui-table fixed compact>
                                <sui-table-header>
                                    <sui-table-row>
                                        <sui-table-header-cell>Catálogo</sui-table-header-cell>
                                        <sui-table-header-cell>Total</sui-table-header-cell>
                                        <sui-table-header-cell>Fecha carga</sui-table-header-cell>
                                    </sui-table-row>
                                </sui-table-header>
                                <sui-table-body>
                                    <sui-table-row>
                                        <sui-table-cell>Localidades </sui-table-cell>
                                        <sui-table-cell>{{ totalColonies }} </sui-table-cell>
                                        <sui-table-cell> </sui-table-cell>
                                    </sui-table-row>
                                    <sui-table-row>
                                        <sui-table-cell>Sepomex</sui-table-cell>
                                        <sui-table-cell>{{ totalRecords }} </sui-table-cell>
                                        <sui-table-cell>{{ sepomexUploadDate }} </sui-table-cell>
                                    </sui-table-row>
                                </sui-table-body>
                            </sui-table>
                            <h3>Revisar clientes</h3>
                            <sui-table fixed compact>
                                <sui-table-body>
                                    <sui-table-row>
                                        <sui-table-cell>Clientes con Colonia (otro) </sui-table-cell>
                                        <sui-table-cell>{{ clientsOtherColonie }} </sui-table-cell>
                                        <sui-table-cell> </sui-table-cell>
                                    </sui-table-row>
                                </sui-table-body>
                            </sui-table>
                        </div>
                        <div class="column">
                            <h3>Ubicación clientes</h3>
                            <sui-table fixed compact>
                                <sui-table-header>
                                    <sui-table-row>
                                        <sui-table-header-cell>Estado</sui-table-header-cell>
                                        <sui-table-header-cell></sui-table-header-cell>
                                    </sui-table-row>
                                </sui-table-header>
                                <sui-table-body>
                                    <sui-table-row v-for="(state, index) in clientsLocations" :key="index">
                                        <sui-table-cell>{{ state.stateName }}</sui-table-cell>
                                        <sui-table-cell text-align="center">{{ state.totalClients }}</sui-table-cell>
                                    </sui-table-row>
                                </sui-table-body>
                            </sui-table>
                        </div>
                        <div class="column">
                            <h3>Clientes código postal No localizado</h3>
                            <sui-table fixed compact>
                                <sui-table-header>
                                    <sui-table-row>
                                        <sui-table-header-cell>Código</sui-table-header-cell>
                                        <sui-table-header-cell>Cliente</sui-table-header-cell>
                                        <sui-table-header-cell>Estado</sui-table-header-cell>
                                    </sui-table-row>
                                </sui-table-header>
                                <sui-table-body>
                                    <sui-table-row v-for="item of clientsPostalInvalid" :key="item.postalCode">
                                        <sui-table-cell> {{ item.postalCode }} </sui-table-cell>
                                        <sui-table-cell> {{ item.clients }} </sui-table-cell>
                                        <sui-table-cell> {{ item.stateName }} </sui-table-cell>
                                    </sui-table-row>
                                </sui-table-body>
                            </sui-table>
                        </div>
                    </div>
                </sui-segment>
            </div>
            <div class="three wide column">
                <sui-grid>
                    <sui-grid-row>
                        <sui-grid-column textAlign="center">
                            <div class="ui vertical fluid menu">
                                <div class="header"><h3>ACCIONES</h3></div>
                                <div class="link item" @click="uloadFileModal = true">
                                    Cargar archivo Serpomex
                                </div>
                                <div class="link item" @click="processNewPostalCodes()">
                                    Transferir nuevos códigos postales
                                </div>
                                <div class="link item" @click="assignInegiCodes()">
                                    Registrar clave de INEGI a localidades sin clave
                                </div>
                                <div class="link item" @click="assignLocationsCodes()">
                                    Registrar clave de colonias, municipio y ciudad a localidades
                                </div>
                            </div>
                        </sui-grid-column>
                    </sui-grid-row>
                </sui-grid>
            </div>
        </div>
        <sui-divider/>
        <div>
            <sui-tab :menu="{ attached: true, tabular: true }">
                <sui-tab-pane title="Diferencias códigos postales">
                    <sui-table fixed compact>
                        <sui-table-header>
                            <sui-table-row>
                                <sui-table-header-cell :width="1">Código</sui-table-header-cell>
                                <sui-table-header-cell>Estado</sui-table-header-cell>
                                <sui-table-header-cell>Códigos postales en SEPOMEX que no existen en nuestro catálogo</sui-table-header-cell>
                                <sui-table-header-cell>Códigos postales en nuestro catálogo que no existen SEPOMEX</sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-header>
                        <sui-table-body>
                            <sui-table-row v-for="(state, index) in resumeStates" :key="index">
                                <sui-table-cell :width="1">{{ state.stateCode }}</sui-table-cell>
                                <sui-table-cell>{{ state.stateName }}</sui-table-cell>
                                <sui-table-cell>
                                    <span v-for="cp in state.locationsNotExist" :key="cp"> {{ cp }} </span>
                                </sui-table-cell>
                                <sui-table-cell>
                                    <span v-for="cp in state.sepomexNotExist" :key="cp"> {{ cp }} </span>
                                </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                    </sui-table>
                </sui-tab-pane>
                <sui-tab-pane title="Diferencias Catálogo Colonias Vs Sepomex">
                    <sui-form v-on:submit.prevent="">
                        <div class="four fields">
                            <sui-form-field>
                                <label> Estado </label>
                                <select class="ui fluid dropdown"
                                    v-model="stateCode">
                                    <option v-for="state in statesCodes" :value="state.stateCode" :key="state.stateCode">{{state.stateName}}</option>
                                </select>
                            </sui-form-field>
                            <sui-form-field>
                                <label> &nbsp; </label>
                                <sui-button positive size="mini" :class="['floated']" @click="compareColonies">Analizar</sui-button><br>
                            </sui-form-field>
                        </div>
                    </sui-form>
                    <sui-table fixed compact>
                        <sui-table-header>
                            <sui-table-row>
                                <sui-table-header-cell :width="1">Código postal</sui-table-header-cell>
                                <sui-table-header-cell :width="1">Clientes</sui-table-header-cell>
                                <sui-table-header-cell>Catálogo BLU</sui-table-header-cell>
                                <sui-table-header-cell>Sepomex</sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-header>
                        <sui-table-body>
                            <sui-table-row v-for="(location, index) in diferencesColonies" :key="index">
                                <sui-table-cell :width="1">{{ location.postalCode }}</sui-table-cell>
                                <sui-table-cell :width="1" text-align="center"  @click="showClients(location.postalCode)">
                                    <sui-label v-if="location.totalClients > 0" basic size="mini" style="margin-top: 5px;" title="Total clientes">
                                        <sui-icon name="users" /> {{ location.totalClients }}
                                    </sui-label>
                                </sui-table-cell>
                                <sui-table-cell>
                                    <h5> En Catálogo BLU </h5>
                                    <sui-table basic='very' compact="very">
                                        <sui-table-body>
                                            <sui-table-row v-for="item of location.locationsBlu" :key="item.colony">
                                                <sui-table-cell :width="1">
                                                    <span v-if="item.valid == true"><i class="green center aligned check circle icon center aligned"></i></span>
                                                </sui-table-cell>
                                                <sui-table-cell :width="3"> {{ item.colony }} </sui-table-cell>
                                                <sui-table-cell :width="1"> {{ item.colony_type }} </sui-table-cell>
                                                <sui-table-cell :width="2"> {{ item.location_name }} </sui-table-cell>
                                                <sui-table-cell :width="1">
                                                    <sui-label v-if="item.clients > 0" basic size="mini" class="blue" title="Clientes"> <sui-icon name="users" /> {{ item.clients }} </sui-label>
                                                </sui-table-cell>
                                                <sui-table-cell :width="1">
                                                    <span v-if="!item.valid == true && (item.clients === 0 || item.clients === null)">
                                                        <i class="red center aligned close circle icon center aligned" title="Eliminar" @click="deleteLocation(item.colonyId)"></i>
                                                    </span>
                                                    <span v-if="!item.valid == true">
                                                        <i class="blue center aligned random icon center aligned" title="Asociar" @click="relateLocation(item, location.locationsSepomex)"></i>
                                                    </span>
                                                </sui-table-cell>
                                            </sui-table-row>
                                        </sui-table-body>
                                    </sui-table>
                                </sui-table-cell>
                                <sui-table-cell>
                                    <h5> En Sepomex </h5>
                                    <sui-table basic='very' compact="very">
                                        <sui-table-body>
                                            <sui-table-row v-for="item of location.locationsSepomex" :key="item.colony_name">
                                                <sui-table-cell :width="3"> {{ item.colony_name }} </sui-table-cell>
                                                <sui-table-cell :width="1"> {{ item.colony_type }} </sui-table-cell>
                                                <sui-table-cell :width="2"> {{ item.municipality_name }} </sui-table-cell>
                                                <sui-table-cell :width="1">
                                                    <span v-if="item.valid == true"><i class="green center aligned check circle icon center aligned"></i></span>
                                                    <span v-else><i class="blue center aligned download icon center aligned" title="Agregar a BLU"></i></span>
                                                </sui-table-cell>
                                            </sui-table-row>
                                        </sui-table-body>
                                    </sui-table>
                                </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                    </sui-table>
                </sui-tab-pane>
                <sui-tab-pane title="Localidades sin Clave Inegi">
                    <sui-form v-on:submit.prevent="">
                        <div class="four fields">
                            <sui-form-field>
                                <label> Estado </label>
                                <select class="ui fluid dropdown"
                                    v-model="stateCode">
                                    <option v-for="state in statesCodes" :value="state.stateCode" :key="state.stateCode">{{state.stateName}}</option>
                                </select>
                            </sui-form-field>
                            <sui-form-field>
                                <label> &nbsp; </label>
                                <sui-button positive size="mini" :class="['floated']" @click="getLocationsInegi">Obtener</sui-button><br>
                            </sui-form-field>
                        </div>
                    </sui-form>
                    <sui-table fixed compact>
                        <sui-table-header>
                            <sui-table-row>
                                <sui-table-header-cell>Código postal</sui-table-header-cell>
                                <sui-table-header-cell>Localidad</sui-table-header-cell>
                                <sui-table-header-cell>Tipo localidad</sui-table-header-cell>
                                <sui-table-header-cell>Ciudad</sui-table-header-cell>
                                <sui-table-header-cell>Municipio</sui-table-header-cell>
                                <sui-table-header-cell>Código municipio</sui-table-header-cell>
                                <sui-table-header-cell>Tipo zona </sui-table-header-cell>
                                <sui-table-header-cell :width="1"></sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-header>
                        <sui-table-body>
                            <sui-table-row v-for="(location, index) in locationsInegi" :key="index">
                                <sui-table-cell >{{ location.cp }}</sui-table-cell>
                                <sui-table-cell >{{ location.colony }}</sui-table-cell>
                                <sui-table-cell >{{ location.colony_type }}</sui-table-cell>
                                <sui-table-cell >{{ location.city }}</sui-table-cell>
                                <sui-table-cell >{{ location.location_name }}</sui-table-cell>
                                <sui-table-cell >{{ location.municipality_code }}</sui-table-cell>
                                <sui-table-cell >{{ location.zone_type }}</sui-table-cell>
                                <sui-table-cell >
                                    <i class="blue center aligned random icon center aligned" title="Relacionar" @click="relateCode(location)"></i>
                                </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                    </sui-table>
                </sui-tab-pane>
            </sui-tab>
        </div>
        <sui-modal v-model="clientsModal" size="large">
            <sui-modal-header>Clientes en código postal</sui-modal-header>
            <sui-modal-content>
                <div style="max-width: 100%; max-height: 600px; overflow-x: scroll;">
                    <sui-table fixed>
                        <sui-table-header>
                            <sui-table-row>
                                <sui-table-header-cell> Cliente </sui-table-header-cell>
                                <sui-table-header-cell> Id Colonia </sui-table-header-cell>
                                <sui-table-header-cell> Colonia </sui-table-header-cell>
                                <sui-table-header-cell> Cp </sui-table-header-cell>
                                <sui-table-header-cell> Ciudad </sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-header>
                        <sui-table-body>
                            <sui-table-row v-for="client in clientsData" :key="client.clientId">
                                <sui-table-cell> {{ client.entityName }} </sui-table-cell>
                                <sui-table-cell> {{ client.colonyId }} </sui-table-cell>
                                <sui-table-cell>
                                    {{ client.colonyId === 0 ? client.colony : client.colonyName }}
                                </sui-table-cell>
                                <sui-table-cell> {{ client.cp }} </sui-table-cell>
                                <sui-table-cell>
                                    {{ client.cityLocation }} </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                        <sui-table-footer>
                            <sui-table-row >
                                <sui-table-header-cell colspan="5">
                                </sui-table-header-cell>
                            </sui-table-row>
                        </sui-table-footer>
                    </sui-table>
                </div>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button negative @click="clientsModal = false">Cerrar</sui-button>
            </sui-modal-actions>
        </sui-modal>
        <sui-modal v-model="uloadFileModal" size="large">
            <sui-modal-header>Cargar archivo Localidades Sepomex</sui-modal-header>
            <sui-modal-content>
                <sui-form v-on:submit.prevent="">
                <div class="two fields">
                    <sui-form-field>
                        <label>Seleccione archivo de SEPOMEX a importar (XLSX)</label>
                        <input type="file" name="file" ref="file" @change="handleFileUpload()"/>
                    </sui-form-field>
                    <sui-form-field>
                        <label> &nbsp; </label>
                        <sui-button primary size="mini" @click="submitFile">Cargar y procesar</sui-button>
                    </sui-form-field>
                </div>
            </sui-form>
            </sui-modal-content>
            <sui-modal-actions>
                <sui-button negative @click="uloadFileModal = false">Cerrar</sui-button>
            </sui-modal-actions>
        </sui-modal>
        <sui-modal v-model="processStatesModal" size="small">
            <sui-modal-header>Procesando</sui-modal-header>
            <sui-modal-content>
                <div style="max-width: 100%; max-height: 600px; overflow-y: scroll;">
                    <label> Procesando </label>
                    <sui-table basic='very' compact="very">
                        <sui-table-body>
                            <sui-table-row v-for="state of this.statesProcessed" :key="state.stateCode">
                                <sui-table-cell :width="1">
                                    {{ state.stateCode }}
                                </sui-table-cell>
                                <sui-table-cell :width="4"> {{  state.stateNameProcessed }} </sui-table-cell>
                            </sui-table-row>
                        </sui-table-body>
                    </sui-table>
                </div>
            </sui-modal-content>
        </sui-modal>
    </div>
    <RelateInegiCode :key="relateInegiCodeKey" :showModalRelateCode="showModalRelateCode" :location="location" @modalResponse="actionLocation"/>
    <RelateLocations :key="relateLocationsKey" :showModalRelateLocation="showModalRelateLocation" :location="location" @modalResponse="actionLocationUpdate"/>
    </section>
</template>

<script>
import Utils from '@/common/Utils.js'
import LocationsService from '@/services/LocationsService'
import RelateInegiCode from '@/components/Modals/RelateInegiCode.vue'
import RelateLocations from '@/components/Modals/RelateLocations.vue'

export default {
    name: 'ImportLocations',
    components: { RelateInegiCode, RelateLocations },
    data () {
        return {
            baseUrl: process.env.VUE_APP_BASEPATH || '/',
            file: '',
            fileName: '',
            stateCode: '',
            location: {},
            clientsData: [],
            statesCodes: [],
            totalRecords: 0,
            resumeStates: [],
            totalLocations: 0,
            totalColonies: 0,
            locationsInegi: [],
            clientsInStates: [],
            clientsLocations: [],
            clientsModal: false,
            statesProcessed: [],
            newLocationsData: [],
            sepomexUploadDate: '',
            clientsOtherColonie: 0,
            stateNameProcessed: '',
            resumeStatesDetail: [],
            clientsPostalInvalid: [],
            diferencesColonies: [],
            diferencesLocations: [],
            relateInegiCodeKey: 100,
            relateLocationsKey: 200,
            instructionsModal: false,
            currentLocationsData: [],
            showModalRelateCode: false,
            showModalRelateLocation: false,
            notFoundLocations: 0,
            uloadFileModal: false,
            processStatesModal: false,
            notFoundPostalCodesSepomex: 0
        }
    },
    async mounted () {
        if (!Utils.userHasPerm('can_admin_locations')) {
            this.$swal({
                title: 'No tienes permiso de administrar localidades',
                icon: 'error',
                showCancelButton: false,
                confirmButtonText: 'Salir',
                confirmButtonColor: '#2BBA45',
                showCloseButton: false
            }).then(async (result) => {
                let routeData = this.$router.resolve({ name: 'home' })
                window.open(routeData.href, '_self')
            })
        }

        this.loader = this.$loading.show()
        await this.resumeClientsLocations()
        await this.clientsPostalCodeInvalid()
        await this.loadStates()

        let response = await this.searchData()
        this.loader.hide()
        if (response.status === 'success') {
            this.totalRecords = response.totalRecords
            this.totalColonies = response.totalColonies
            this.totalLocations = response.totalLocations
            this.sepomexUploadDate = response.sepomexUploadDate
            if (response.resumeStates && response.resumeStates.length > 0) {
                this.resumeStates = response.resumeStates
                this.clientsInStates = response.resumeStates.filter((r) => r.clients > 0)
                await this.locationsDiferences()
            }
        }
    },
    methods: {
        handleFileUpload () {
            this.file = this.$refs.file.files[0]
        },

        async searchData () {
            let response = await LocationsService.searchData()
            return response
        },

        async resumeClientsLocations () {
            let response = await LocationsService.clientsLocations()
            this.clientsLocations = response.clientsLocations
        },

        async clientsPostalCodeInvalid () {
            let response = await LocationsService.clientsPostalCodeInvalid()
            this.clientsPostalInvalid = response.data
            this.clientsOtherColonie = response.withColonyIdCero
        },

        async loadStates () {
            let response = await LocationsService.loadStates()
            this.statesCodes = response.data
        },

        cleanArray () {
            this.diferencesColonies = []
            this.diferencesLocations = []
        },

        async submitFile () {
            if (!this.file) {
                this.$swal({
                    toast: true,
                    position: 'top',
                    showConfirmButton: false,
                    timerProgressBar: true,
                    showCloseButton: true,
                    icon: 'error',
                    title: 'Alerta',
                    html: `Selecciona el archivo con la información a importar`
                })
                return
            }

            this.$swal({
                title: '¿Deseas cargar y procesar el archivo?',
                html: '',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.loader = this.$loading.show()
                    this.resumeStates = []
                    let response = await LocationsService.uploadSepomexFile(this.file)
                    this.loader.hide()
                    if (response.status === 'success') {
                        this.uloadFileModal = false
                        this.fileName = response.fileName
                        await this.processFile()
                    }
                }
            })
        },

        async processFile () {
            this.loader = this.$loading.show()
            let response = await LocationsService.processFile(this.fileName)
            this.loader.hide()
            if (response.status === 'success') {
                this.resumeStates = response.resumeStates
                this.totalRecords = response.totalRecords
                await this.locationsDiferences()
            } else {
                this.$swal.fire({
                    title: 'Error',
                    text: 'Archivo no se pudo procesar',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Aceptar'
                })
            }
        },

        async locationsDiferences () {
            this.loader = this.$loading.show()
            let response = await LocationsService.locationsDiferences(this.resumeStates)
            this.loader.hide()
            if (response.status === 'success') {
                this.resumeStates = response.resumeStates
            }
        },

        async getLocationsInegi () {
            this.loader = this.$loading.show()
            let response = await LocationsService.getLocationsInegi(this.stateCode)
            this.loader.hide()
            if (response.status === 'success') {
                this.locationsInegi = response.data
            }
        },

        async compareColonies () {
            if (this.stateCode === '') {
                this.$swal.fire({
                    title: 'Error',
                    text: 'Favor de seleccionar un estado',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'Aceptar'
                })
                return
            }
            this.cleanArray()
            this.loader = this.$loading.show()
            let response = await LocationsService.compareColonies(this.stateCode)
            if (response.status === 'success') {
                this.diferencesColonies = response.data
            }
            this.loader.hide()
        },

        async showClients (postalCode) {
            this.loader = this.$loading.show()
            this.clientsData = []
            let response = await LocationsService.getClients(postalCode)
            if (response.status === 'success') {
                this.clientsModal = true
                this.clientsData = response.data
            }
            this.loader.hide()
        },

        async postalCodesStatesDetail () {
            let response = await LocationsService.postalCodesStatesDetail(this.resumeStates)
            if (response.status === 'success') {
                this.resumeStatesDetail = response.data
                if (this.resumeStatesDetail > 0) {
                    this.notFoundLocations = this.resumeStatesDetail.totalLocations
                }
            }
        },

        async relateCode (location) {
            this.location = location
            this.showModalRelateCode = true
        },

        async relateLocation (location, locationSepomex) {
            this.location = {
                location,
                locationSepomex
            }
            this.showModalRelateLocation = true
        },

        async deleteLocation (colonyId) {
            this.$swal({
                title: '¿Deseas borrar la localidad?',
                html: 'Una vez realizada no se puede cancelar',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.loader = this.$loading.show()
                    let response = await LocationsService.deleteLocation(colonyId)
                    this.loader.hide()
                    if (response.status === 'success') {
                        if (response.result > 0) {
                            for (let data of this.diferencesColonies) {
                                data.locationsBlu.splice(data.locationsBlu.findIndex(v => v.colonyId === colonyId), 1)
                            }
                        }
                    }
                }
            })
        },

        resetLocations () {
            this.diferencesLocations = []
        },

        async processNewPostalCodes () {
            this.$swal({
                title: '¿Deseas registrar los códigos postales y localidades de SEPOMEX que no existen?',
                html: 'Una vez realizada no se puede cancelar',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.processStatesModal = true
                    this.loader = this.$loading.show()
                    for (let state of this.statesCodes) {
                        await LocationsService.addNewPostalCodes(state.stateCode)
                        this.statesProcessed.push({
                            stateCode: state.stateCode,
                            stateNameProcessed: state.stateName
                        })
                        this.statesProcessed.sort((b, a) => (a.stateCode > b.stateCode) ? 1 : ((b.stateCode > a.stateCode) ? -1 : 0))
                    }
                    this.processStatesModal = false
                    this.loader.hide()
                    this.$router.go()
                }
            })
        },

        async assignInegiCodes () {
            this.$swal({
                title: '¿Deseas registrar los códigos INEGI a localidades que no lo tengan?',
                html: 'Una vez realizada no se puede cancelar',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.processStatesModal = true
                    this.loader = this.$loading.show()
                    for (let state of this.statesCodes) {
                        await LocationsService.assignInegiCodes(state.stateCode)
                        this.statesProcessed.push({
                            stateCode: state.stateCode,
                            stateNameProcessed: state.stateName
                        })
                        this.statesProcessed.sort((b, a) => (a.stateCode > b.stateCode) ? 1 : ((b.stateCode > a.stateCode) ? -1 : 0))
                    }
                    this.processStatesModal = false
                    this.loader.hide()
                    this.$router.go()
                }
            })
        },

        async assignLocationsCodes () {
            this.$swal({
                title: '¿Deseas registrar los códigos SEPOMEX a localidades que no lo tengan?',
                html: 'Una vez realizada no se puede cancelar',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                showCloseButton: false,
                allowOutsideClick: false
            }).then(async (result) => {
                if (result.value === true) {
                    this.processStatesModal = true
                    this.loader = this.$loading.show()
                    for (let state of this.statesCodes) {
                        await LocationsService.assignLocationsCodes(state.stateCode)
                        this.statesProcessed.push({
                            stateCode: state.stateCode,
                            stateNameProcessed: state.stateName
                        })
                        this.statesProcessed.sort((b, a) => (a.stateCode > b.stateCode) ? 1 : ((b.stateCode > a.stateCode) ? -1 : 0))
                    }
                    this.processStatesModal = false
                    this.loader.hide()
                    this.$router.go()
                }
            })
        },

        async actionLocation (updatedRecord) {
            this.showModalRelateCode = false
            if (updatedRecord) {
                this.locationsInegi.splice(this.locationsInegi.findIndex(v => v.colony_id === updatedRecord.colonyId), 1)
            }
        },

        async actionLocationUpdate (updatedRecord) {
            this.showModalRelateLocation = false
            if (updatedRecord) {
                for (let data of this.diferencesColonies) {
                    if (data.postalCode !== updatedRecord.postal_code) continue
                    for (let item of data.locationsBlu) {
                        if (item.colonyId === updatedRecord.colonyId) {
                            item.colony = updatedRecord.colony
                            item.colony_type = updatedRecord.colony_type
                            item.valid = true
                        }
                    }

                    for (let item of data.locationsSepomex) {
                        if (item.colony_name === updatedRecord.colony && item.colony_type === updatedRecord.colony_type) {
                            item.valid = true
                        }
                    }
                }
            }
        }
    }
}
</script>
